module.exports = __webpack_public_path__ + "static/media/cases_logos_eventos_04.0bdbeb0c.jpg";